var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6221 8.81728C18.9684 9.21752 18.4269 9.77709 18.0483 10.4436C17.6697 11.1101 17.4664 11.8618 17.4574 12.6283C17.46 13.491 17.7156 14.3339 18.1925 15.0528C18.6694 15.7716 19.3468 16.3348 20.1406 16.6725C19.8276 17.6823 19.3644 18.6393 18.7665 19.5112C17.9111 20.7427 17.0166 21.974 15.6556 21.974C14.2946 21.974 13.9446 21.1833 12.3761 21.1833C10.8466 21.1833 10.3021 22 9.05772 22C7.81332 22 6.94494 20.8593 5.94679 19.4594C4.6283 17.4983 3.90368 15.1983 3.85986 12.8356C3.85986 8.94692 6.38757 6.88598 8.87624 6.88598C10.1985 6.88598 11.3003 7.75436 12.1299 7.75436C12.9206 7.75436 14.152 6.83402 15.6556 6.83402C16.4287 6.81407 17.1948 6.98453 17.8865 7.33037C18.5782 7.67622 19.1742 8.18684 19.6221 8.81728ZM14.9427 5.18787C15.6055 4.40817 15.9807 3.42466 16.0057 2.40162C16.0068 2.26675 15.9937 2.13214 15.9667 2C14.8282 2.11122 13.7754 2.65386 13.0242 3.51662C12.355 4.26525 11.9657 5.2225 11.9224 6.22569C11.9229 6.34769 11.936 6.46932 11.9613 6.58865C12.0511 6.60562 12.1422 6.61431 12.2335 6.61463C12.7583 6.57288 13.269 6.42487 13.7347 6.1796C14.2005 5.93433 14.6115 5.59692 14.9427 5.18787Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.c9937f2482e91d24eea0a919586ee3c9.svg";
export { ForwardRef as ReactComponent };